import styled, { css } from 'styled-components';

export const CarouselWrapper = styled.div`
  text-align: center;
  overflow: hidden;
`;

export const SlidesTrack = styled.div<{ $activeIndex: number; $slideCount: number }>`
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: ${props => (props.$slideCount * 80)}%;
  gap: 40px;
  @media (max-width: 768px) {
    width: ${props => (props.$slideCount * 100)}%;
  }
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 25px;
`;

export const Dot = styled.div<{ $active: boolean }>`
  height: 4px;
  margin: 0 4px;
  cursor: pointer;
  transition: background-color 0.3s, width 0.3s, border-radius 0.3s;
  width: 4px;
  border-radius: 50%;
  background-color: #e0e0e0;

  ${props => props.$active && css`
    width: 35px;
    border-radius: 4px;
    background-color: #5E5779;
  `}
`;